import React from 'react';
import { CalendarPlusIcon } from 'lucide-react';
import { SmartLink } from '../components/SmartLink';
import { ConfirmationCard } from '../components/utility/ConfirmationCard';
import { LinkCardGrid } from '../components/utility/LinkCardGrid';
import { whileYouWait } from '../data/utilityPages';
type ThanksProps = {
  variant: 'demo' | 'general';
};
export function Thanks({
  variant
}: ThanksProps) {
  return <main className="hero-surface w-full" data-id="element-2240" data-mp="24lh4tpmbqmle">
      <div className="mx-auto max-w-shell px-6 pb-20 pt-14 lg:pb-28 lg:pt-20" data-id="element-2241" data-mp="24ntp49fk191m">
        {variant === 'demo' ? <>
            <ConfirmationCard title="Your demo request is in" body="We’ll contact you within 1 business day to schedule it." data-id="element-2242" data-mp="1vlc1pro5yad1">
              <a href="#" className="mt-7 inline-flex items-center gap-2 rounded-[7px] border border-ink/20 px-4 py-2.5 text-[14px] font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink/45" data-id="element-2243" data-mp="1zoqhch86wopy">
                <CalendarPlusIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-2244" data-mp="3kvjqj3zkgirs" />
                Add to calendar
              </a>
              <p className="mt-3 text-[13px] text-ink-muted" data-id="element-2245" data-mp="3fvfgnwt5ymaj">We’ll send the confirmed time by your preferred contact method.</p>
            </ConfirmationCard>

            <div className="mx-auto mt-14 max-w-[880px]" data-id="element-2246" data-mp="3pocuhpn7nn2t">
              <LinkCardGrid headingId="while-you-wait" heading="While you wait" items={whileYouWait} data-id="element-2247" data-mp="31xqxquinpp84" />
            </div>
          </> : <ConfirmationCard title="Thanks, we’ve received your message" body="Our team will reply soon." data-id="element-2248" data-mp="2wzxr60dfyt7b">
            <SmartLink href="/" className="mt-8 inline-flex h-12 w-full items-center justify-center rounded-[7px] bg-brand px-6 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover sm:w-auto" data-id="element-2249" data-mp="3bxhs8w77w487">
              Back to homepage
            </SmartLink>
          </ConfirmationCard>}
      </div>
    </main>;
}